import { render, staticRenderFns } from "./TouchNGo.vue?vue&type=template&id=6b7cdf52&scoped=true"
import script from "./TouchNGo.vue?vue&type=script&lang=js"
export * from "./TouchNGo.vue?vue&type=script&lang=js"
import style0 from "./TouchNGo.vue?vue&type=style&index=0&id=6b7cdf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cdf52",
  null
  
)

export default component.exports